import { en } from '@/shared/locales/en'

type NestedPaths<T extends object, K extends keyof T = keyof T> = K extends string
  ? T[K] extends Record<string, unknown>
    ? `${K}.${NestedPaths<T[K]>}`
    : K
  : never

export type TranslationKey = NestedPaths<typeof en>

const getByPath = (obj: Record<string, unknown>, path: string): string => {
  const value = path.split('.').reduce<unknown>((current, key) => {
    return current !== null && typeof current === 'object'
      ? (current as Record<string, unknown>)[key]
      : undefined
  }, obj)
  return typeof value === 'string' ? value : path
}

export const t = (key: TranslationKey, params?: Record<string, string | number>): string => {
  const value = getByPath(en as Record<string, unknown>, key)
  if (!params) return value
  return Object.entries(params).reduce(
    (result, [paramKey, paramValue]) => result.replace(`{${paramKey}}`, String(paramValue)),
    value,
  )
}
